import { setSlicePrompts, setSliceRemoveOriginAudio } from '../../../../redux/slices/FJSliceAiVideoDub';
import FJAiVideoDubLeft from '../view/FJAiVideoDubLeft';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import FJActionAiVideoDub from '../../../../redux/action/FJActionAiVideoDub';
import FJConstant from '../../../../constants/FJConstant';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJAiVideoDubLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const prompts = useSelector(state => state.aiVideoDub.prompts);
    const removeOriginAudio = useSelector(state => state.aiVideoDub.removeOriginAudio);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const useCredit = useSelector(state => state.aiVideoDub.useCredit);
    const videoInfo = useSelector(state => state.aiVideoDub.videoInfo);

    const isFree = useMemo(() => {
        return (creditNumber < useCredit || creditNumber === 0) && freeNumCreation > 0;
    }, [creditNumber, freeNumCreation, useCredit]);

    const _onChangePrompts = useCallback(
        e => {
            dispatch(setSlicePrompts(e.target.value));
        },
        [dispatch],
    );

    const _onChangeRemoveOriginAudio = useCallback(
        value => {
            dispatch(setSliceRemoveOriginAudio(value));
        },
        [dispatch],
    );
    const disable = useMemo(() => {
        return (
            taskStatus !== FJConstant.ERROR && taskStatus !== FJConstant.SUCCESS && taskStatus !== FJConstant.DEFAULT
        );
    }, [taskStatus]);

    const _onGenerate = useCallback(() => {
        if (disable) return;
        dispatch(FJActionAiVideoDub.generateAction());
    }, [dispatch, disable]);

    return (
        <FJAiVideoDubLeft
            prompts={prompts}
            removeOriginAudioActive={removeOriginAudio}
            onChangePrompts={_onChangePrompts}
            onChangeRemoveOriginAudio={_onChangeRemoveOriginAudio}
            onGenerate={_onGenerate}
            taskStatus={taskStatus}
            isFree={isFree}
            useCredit={useCredit}
            freeNumCreation={freeNumCreation}
            disable={disable}
            videoInfo={videoInfo}
        />
    );
};

export default FJAiVideoDubLeftContainer;
